angular.module('core')
  .controller('FamilyInvitationLettersModalController', [
    '$modalInstance',
    '$scope',
    'dblProductResourcesService',
    'item',
    'authentication',
    function(
      $modalInstance,
      $scope,
      dblProductResourcesService,
      item,
      authentication) {

      $scope.item = item;
      var idType;
      switch ($scope.item.type) {
        case 'school':
          idType = 'sid';
          break;
        default:
          idType = 'cid';
      }

      var customer = authentication.getCustomer();
      $scope.ssoOnly = authentication.isSsoLoginOnly(customer);

      $scope.englishParentInvitationLetterUrl =
        dblProductResourcesService.getParentInvitationLetterUrl(idType, item.id);
      $scope.spanishParentInvitationLetterUrl =
        dblProductResourcesService.getParentInvitationLetterUrl(idType, item.id, 'es_US');

      $scope.englishParentInvitationLetterSSOUrl =
        dblProductResourcesService.getParentInvitationLetterSSOUrl();
      $scope.spanishParentInvitationLetterSSOUrl =
        dblProductResourcesService.getParentInvitationLetterSSOUrl('es_US');

      $scope.modalClose = function() {
        $modalInstance.close();
      };
    }
  ]);

